import { useRouter } from '@uirouter/react';
import { useImmerAtom, useSetImmerAtom } from 'jotai-immer';
import { ROUTE_CREATE, ROUTE_UPDATE } from '../../payor_const';
import { pageStateAtom, payorDataAtom, tableStateAtom } from '../payor_list_atoms';
import { PageStoreHook, PayorDataItem } from '../payor_list_types';
import { useCallback } from 'react';
import { tableDataVM } from '../../../../core/table/table_view_models';
import apiSvc from '../../../../core/services/apiSvc';
import { GET_LIST } from '../../data/payorRepo';
import { payorListVM } from '../table/usePayorListTableInit';

export const usePayorListStore = (): PageStoreHook => {
    const router = useRouter();
    const [state] = useImmerAtom(pageStateAtom);
    const setList = useSetImmerAtom(payorDataAtom);
    const setState = useSetImmerAtom(tableStateAtom);

    const getListAsync = useCallback(async () => {
        try {
            const r = await apiSvc.getEntityList<PayorDataItem>(GET_LIST, {});
            setList(draft => {
                draft.dataItems = payorListVM(r);
                draft.items = [];
            });
        } catch (err: any) {
            setList(() => tableDataVM<PayorDataItem>());
        } finally {
            setState(draft => {
                draft.waiting = false;
                return draft;
            });
        }
    }, [setList, setState]);

    const getList = useCallback((): void => {
        setState(draft => {
            draft.waiting = true;
            return draft;
        });
        getListAsync();
    }, [getListAsync, setState]);

    const routeToCreate = useCallback(() => {
        router.stateService.go(ROUTE_CREATE);
    }, [router.stateService]);

    const routeToEdit = useCallback(
        (rowItem: PayorDataItem) => {
            router.stateService.go(ROUTE_UPDATE, { Id: rowItem.Id });
        },
        [router.stateService],
    );

    return {
        canEdit: state.canEdit,
        routeToCreate,
        routeToEdit,
        getList,
    };
};
